import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { TreasuryKRISummaryProvider } from "../../../context/TreasuryKRISummaryContext";
import WhatWeDo from "../../whatWeDo/WhatWeDo.component";
import useStyles from "./TreasuryKRISummary.styles";
import TreasuryKRISummaryFiltersAndReports from "./TreasuryKRISummaryFiltersAndReports.component";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.primary,
}));

const TreasuryKRISummary = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.page}>
      <Grid container spacing={2}>
        <TreasuryKRISummaryProvider>
          <TreasuryKRISummaryFiltersAndReports />
        </TreasuryKRISummaryProvider>
        <Grid size={{ xs: 12, md: 12, lg: 12 }} sx={{ display: "none" }}>
          <Item>
            <WhatWeDo />
          </Item>
        </Grid>
      </Grid>
    </div>
  );
};

export default TreasuryKRISummary;
